import { Directive, ViewContainerRef, Input, EventEmitter, ComponentRef, Output, ComponentFactoryResolver, OnInit, AfterViewChecked, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { DynamicAttribute } from '../dynamic-attribute';
import { AttributeComponent } from '../interfaces/attribute.component';
import { FormGroupDirective, ControlContainer } from '@angular/forms';

@Directive({
  selector: '[attribute-host]',
  providers: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})

export class AttributeDirective implements OnInit {
  @Input() key: number;
  @Input() dynamicAttribute: DynamicAttribute;

  @Output() onRemove: EventEmitter<number> = new EventEmitter<number>();

  private _componentRef: ComponentRef<AttributeComponent> = null;

  constructor(
    public viewContainerRef: ViewContainerRef,
    private cfr: ComponentFactoryResolver,
    private parent: FormGroupDirective
  ) { }

  ngOnInit(): void {
    const factory = this.cfr.resolveComponentFactory<AttributeComponent>(
      this.dynamicAttribute.component as any
    );

    const compRef = this.viewContainerRef.createComponent(factory);
    this._componentRef = compRef;
 
    const instance = compRef.instance;
    instance.attributeDefinition = this.dynamicAttribute.definition;
    instance.formGroup = this.parent.form;

    compRef.changeDetectorRef.detectChanges();
  }

  public value() {
    return this._componentRef.instance?.value();
  }
}
